import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
import router from '../router';

Vue.use(Toast);



//创建axios实例对象
const  instance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
    timeout: 5000,
    withCredentials: true,
})

//请求拦截器
instance.interceptors.request.use(config=>{
    if(config.method === "post"){
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers, 
            'token': Base64.encode(localStorage.getItem('token')),
            'lang': localStorage.getItem("lang") || 'en'
         
        }
    }
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    const data = res.data;
    if(data && (data.code === 401 || data.code === 403)){
        console.log('检测到认证错误，清除token并跳转登录页', data);
        localStorage.clear();
        if(router.currentRoute.path !== '/Login'){
            router.replace({path:'/Login'});
        }
        return Promise.reject(data);
    }
    return res
},err=>{
    if(err.response && err.response.status === 401){
        console.log('HTTP 401错误，清除token并跳转登录页', err);
        localStorage.clear();
        if(router.currentRoute.path !== '/Login'){
            router.replace({path:'/Login'});
        }
    }
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
                api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export default http

